<div class="hx-pdf-viewer__preview">
  <div #pageContainer class="hx-pdf-viewer__pages">
    @if (isLoading()) {
      <div class="hx-pdf-viewer__state">Loading document...</div>
    } @else if (errorMessage()) {
      <div class="hx-pdf-viewer__state hx-pdf-viewer__state--error">
        {{ errorMessage() }}
      </div>
    }
  </div>
</div>

@if (showActions) {
  <div class="hx-pdf-viewer__actions">
    <span class="hx-pdf-viewer__filename">{{ fileName() }}</span>
    <div class="hx-pdf-viewer__action-group">
      @if (showCloseAction()) {
        <button hxButton variant="outline" context="neutral" (click)="close.emit()">Close</button>
      }
      @if (showDownloadAction()) {
        <button
          hxButton
          variant="fill"
          context="brand"
          fontIcon="download"
          [disabled]="isDownloading()"
          hxTooltip="Download PDF"
          aria-label="Download PDF"
          (click)="download.emit()">
          Download
        </button>
      }
    </div>
  </div>
}
